import _ from 'lodash';
import { FILE_MANAGER_COMPONENT_ACTIONS } from '../../../redux/file-manager-component/file-manager-component.actions';
import { FILES_ACTIONS } from '../../../redux/files/files.actions';
import { Action, Reducer } from '../../../redux/redux.types';
import { OpenFolderResponse } from '../../../types/media-assets';
import { MaybeUndef } from '../../../types/system';
import { FILE_MANAGER_ACTIONS } from './file-manager.actions';
import { SELECTION_ACTIONS } from './selection.actions';

function locateFile(
  state: SelectionState,
  fileIds: string[],
  fileId: MaybeUndef<string>,
): SelectionState {
  if (fileId && fileIds.includes(fileId)) {
    return {
      ...state,
      selectedFileIds: [fileId],
    };
  }

  return state;
}

export interface SelectionState {
  firstSelectedItemId: MaybeUndef<string>;
  selectedFileIds: string[]; // including folders
}

const defaultState: SelectionState = {
  firstSelectedItemId: undefined,
  selectedFileIds: [],
};

export const selection: Reducer<SelectionState, any, string[]> = (
  state: SelectionState = defaultState,
  { type, payload }: Action,
  fileIds: string[],
): SelectionState => {
  switch (type) {
    case SELECTION_ACTIONS.ITEM_SELECTION_WITH_SHIFT: {
      const itemIndex = _.indexOf(fileIds, payload);
      const firstSelectedItemIndex = state.firstSelectedItemId
        ? _.indexOf(fileIds, state.firstSelectedItemId)
        : 0;

      let newSelectedFileIds;

      if (!state.firstSelectedItemId) {
        newSelectedFileIds = _.slice(
          fileIds,
          firstSelectedItemIndex,
          itemIndex + 1,
        );

        return {
          firstSelectedItemId: payload,
          selectedFileIds: newSelectedFileIds,
        };
      }

      newSelectedFileIds =
        itemIndex <= firstSelectedItemIndex
          ? _.slice(fileIds, itemIndex, firstSelectedItemIndex + 1)
          : _.slice(fileIds, firstSelectedItemIndex, itemIndex + 1);

      return {
        ...state,
        selectedFileIds: newSelectedFileIds,
      };
    }

    case SELECTION_ACTIONS.ONE_ITEM_SELECTION:
      return {
        firstSelectedItemId: payload,
        selectedFileIds: [payload],
      };

    case SELECTION_ACTIONS.ADD_ITEM_SELECTED:
      return _.includes(state.selectedFileIds, payload)
        ? state
        : {
            firstSelectedItemId: payload,
            selectedFileIds: [...state.selectedFileIds, payload],
          };

    case SELECTION_ACTIONS.REMOVE_ITEM_SELECTION:
      return _.includes(state.selectedFileIds, payload)
        ? {
            firstSelectedItemId: payload,
            selectedFileIds: _.without(state.selectedFileIds, payload),
          }
        : state;

    case SELECTION_ACTIONS.ITEM_SELECTION_TOGGLE:
      return {
        firstSelectedItemId: payload,
        selectedFileIds: state.selectedFileIds.includes(payload)
          ? _.without(state.selectedFileIds, payload)
          : [...state.selectedFileIds, payload],
      };

    case SELECTION_ACTIONS.ALL_ITEMS_SELECTIONS_TOGGLE:
      return {
        firstSelectedItemId: undefined,
        selectedFileIds: payload ? [...fileIds] : [],
      };

    case FILE_MANAGER_COMPONENT_ACTIONS.FILES_LIST_GET_SUCCESS: {
      const { locateFileId }: OpenFolderResponse = payload;

      return locateFile(state, fileIds, locateFileId);
    }

    case FILE_MANAGER_ACTIONS.NAVIGATE_TO_FILE_IN_CURRENT_FOLDER: {
      return locateFile(state, fileIds, payload);
    }

    case FILES_ACTIONS.FILE_DELETE_SUCCESS:
      return {
        ...state,
        selectedFileIds: _.without(state.selectedFileIds, payload.id),
      };

    default:
      return state;
  }
};
